'use client';

import { Popover, PopoverContent, PopoverTrigger } from '../ui/popover';
import { useState, type PropsWithChildren } from 'react';
import { signOut } from 'next-auth/react';
import { useTranslations } from 'next-intl';
import { Routes } from '@/src/routes/routes';
import { Link } from '@/src/i18n/navigation';
import { trackEvent } from '@/src/lib/amplitude';
import { AmplitudeEventProperties, AmplitudeEvents } from '@/src/lib/amplitude/events';
import useUserStore from '@/src/lib/state-stores/userStore';

async function keycloakSessionLogOut() {
  try {
    await fetch(`/api/auth/logout`, { method: 'GET' });
  } catch (err) {
    // console.error(err);
  }
}

function UserPopover(props: PropsWithChildren & { disabled?: boolean }) {
  const t = useTranslations('header');
  const { clearUser } = useUserStore();
  const [open, setOpen] = useState(false);
  const accountMenu: { link: string; name: string; event: keyof AmplitudeEventProperties }[] = [
    { link: Routes.profile, name: t('profile'), event: AmplitudeEvents.my_account_clicked },
    { link: Routes.addresses, name: t('address'), event: AmplitudeEvents.my_addresses_clicked },
    { link: Routes.order, name: t('orders'), event: AmplitudeEvents.my_orders_clicked },
    { link: Routes.payment, name: t('payment'), event: AmplitudeEvents.my_saved_cards_clicked },
    { link: Routes.joinUs, name: t('Join-us'), event: AmplitudeEvents.join_us },
  ];

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button disabled={props.disabled}>{props.children}</button>
      </PopoverTrigger>
      <PopoverContent className="flex w-60 flex-col space-y-6 pt-4 pb-0">
        {accountMenu.map((item, index) => (
          <Link
            onClick={() => {
              setOpen(false);
              trackEvent(item.event);
            }}
            href={item.link}
            key={index}
            className="text-primary h-7 w-full border-[#ECE9FF] px-6 text-start font-medium hover:opacity-50"
          >
            {item.name}
          </Link>
        ))}

        <button
          className="border-primary-light w-full border-t px-6 py-4 text-start font-bold text-[#B63546] hover:opacity-50"
          onClick={async () => {
            await keycloakSessionLogOut().then(() => signOut({ callbackUrl: '/' }));
            trackEvent(AmplitudeEvents.signed_out);
            clearUser();
          }}
        >
          {t('Log-Out')}
        </button>
      </PopoverContent>
    </Popover>
  );
}

export default UserPopover;
